import { render, staticRenderFns } from "./entregasDinero.vue?vue&type=template&id=fedb197c&scoped=true&"
import script from "./entregasDinero.vue?vue&type=script&lang=js&"
export * from "./entregasDinero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fedb197c",
  null
  
)

export default component.exports